export default __webpack_public_path__ + "static/media/JavaScript.266bd9fb.png";